'use client'

import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { RegisterMedicalSchema, RegisterMedicalFormValues } from '@lib/schemas/auth-schema'
import Multistep, { MultistepStep } from '../../../../components/Multistep'
import PersonalDetailsStep from './PersonalDetailsStep'
import MedicalDetailsStep from './MedicalDetailsStep'
import TermsStep from '../../../components/auth/TermsStep'
import { registerMedicalAction } from '../_actions/register-medical'

const defaultValues: RegisterMedicalFormValues = {
    email: '',
    firstName: '',
    lastName: '',
    image: undefined,
    medicalLicenseNumber: '',
    confirmMedicalRole: false,
    acceptedTerms: false,
    acceptedPrivacy: false
}

export default function RegisterMedicalFlow() {
    const t = useTranslations('auth.register')
    const router = useRouter()

    const steps: MultistepStep<RegisterMedicalFormValues>[] = [
        {
            key: 'personal',
            label: t('steps.personal'),
            description: t('steps.personalDescription'),
            fields: ['email', 'firstName', 'lastName', 'image'],
            Component: PersonalDetailsStep
        },
        {
            key: 'medical',
            label: t('steps.medical'),
            description: t('steps.medicalDescription'),
            fields: ['medicalLicenseNumber', 'confirmMedicalRole'],
            Component: MedicalDetailsStep
        },
        {
            key: 'terms',
            label: t('steps.terms'),
            description: t('steps.termsDescription'),
            fields: ['acceptedTerms', 'acceptedPrivacy'],
            Component: TermsStep
        }
    ]

    const handleSubmit = async (values: RegisterMedicalFormValues) => {
        const formData = new FormData()
        formData.set('email', values.email)
        formData.set('firstName', values.firstName)
        formData.set('lastName', values.lastName)
        formData.set('medicalLicenseNumber', values.medicalLicenseNumber)
        formData.set('confirmMedicalRole', String(values.confirmMedicalRole))
        formData.set('acceptedTerms', String(values.acceptedTerms))
        formData.set('acceptedPrivacy', String(values.acceptedPrivacy))

        if (values.image) {
            const blob = await (await fetch(values.image)).blob()
            formData.set('image', blob, 'avatar.jpg')
        }

        const { redirectUrl } = await registerMedicalAction(formData)
        window.location.assign(redirectUrl)
    }

    return (
        <Multistep
            steps={steps}
            defaultValues={defaultValues}
            schema={RegisterMedicalSchema}
            onSubmit={handleSubmit}
            submitLabel={t('submit')}
            onCancel={() => router.push('/')}
        />
    )
}
